import React from 'react';

const AuthLayout = ({ 
  title, 
  subtitle, 
  icon, 
  iconBgColor = 'bg-jet-blue-100',
  iconColor = 'text-jet-blue-600',
  children,
  showDemo = false,
  demoText = ''
}) => {
  return (
    <div className="min-h-screen bg-jet-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-lg shadow-sm p-8">
          <div className="text-center mb-8">
            {icon && (
              <div className={`inline-flex items-center justify-center w-16 h-16 ${iconBgColor} rounded-full mb-4`}>
                <svg className={`w-8 h-8 ${iconColor}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  {icon}
                </svg>
              </div>
            )}
            
            <h1 className="text-2xl font-bold text-jet-gray-900 mb-2">{title}</h1>
            {subtitle && (
              <p className="text-jet-gray-600">{subtitle}</p>
            )}
          </div>

          {children}

          {showDemo && demoText && (
            <div className="mt-6 bg-jet-blue-50 rounded-lg p-4">
              <p className="text-sm text-jet-blue-800 text-center">
                <strong>Demo:</strong> {demoText}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;